import { Injectable } from '@angular/core';
import $ from 'jquery';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor() { }

  showModal(modalId:string){
    $("body").addClass("overflow-hidden");
    $(".gb-popup[data-tipo='" + modalId + "']").removeClass("d-none");
  }
  hideModal(modalId:string){
    $("body").removeClass("overflow-hidden");
    $(".gb-popup[data-tipo='" + modalId + "']").addClass("d-none");
  }
}
